import { PersonAddAlt1 } from "@mui/icons-material";
import {
    Backdrop,
    Button,
    CircularProgress,
    IconButton,
    ToggleButton,
    ToggleButtonGroup,
} from "@mui/material";
import { useIsMutating } from "@tanstack/react-query";
import classNames from "classnames";
import { useContext, useEffect, useState } from "react";
import CustomerDialog from "../../pages/PosPage/components/CustomerDialog/CustomerDialog";
import SmallTablePlaceholder from "../SmallTablePlaceholder";
import clear from "./clear.svg";
import { useStyles } from "./styles";

import { PosContext } from "../../shared/PosContext";

const AddPaymentWidget = ({
    selectedTip,
    selectedDiscount,
    onUpdateTip,
    onUpdateDiscount,
    onConfirm,
    inAmount,
    amountAfterDiscount,
    orderAmount,
    handlePropertyChange,
    isCreatingInvoice,
    backCallback,
    isLoading,
    paymentType,
    setPaymentType,
    presetDiscount,
    orderOnHouse,
    setOrderOnHouse,
    setSelectedCustomer,
    selectedCustomer,
}) => {
    const classes = useStyles();

    const { refetchCustomers, refetchAddresses, refetchTablesData } =
        useContext(PosContext);

    const isMutating = useIsMutating();

    const [internalMessage, setInternalMessage] = useState(null);
    const [dollarRate, setDollarRate] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    // const [inputsValid, setInputsValid] = useState(true);
    const [changeCustomerDialogOpen, setChangeCustomerDialogOpen] =
        useState(false);

    const tables = [
        {
            name: "Table 1",
            floor: "1",
            actions: [],
            canDoBack: true,
        },
    ];

    // const { sad }

    const userCanGiveDiscount = () => {
        // if (userRole && userRole === "Admin") return true;
        // return false;
        return true;
    };

    const validateInput = () => {
        if ((inAmount - amountAfterDiscount).toFixed(2) < 0) {
            console.log((inAmount - amountAfterDiscount).toFixed(2) < 0);
            setErrorMessage("Amount cant be less than order amount");
            return;
        }

        if (!orderOnHouse && selectedButton !== "Deferred") {
            if (!paymentType || paymentType.length === 0) {
                setErrorMessage("Payment Method is not selected");
                return;
            }
        } else if (selectedButton && selectedButton === "Deferred") {
            if (!selectedCustomer) {
                setErrorMessage("Customer Not Selected");
                return;
            }
        }

        if (onConfirm) {
            onConfirm();
        }
    };

    useEffect(() => {
        // Fetch the dollar rate from an API
        fetch("https://api.exchangerate-api.com/v4/latest/USD")
            .then((response) => response.json())
            .then((data) => {
                // Update the dollar rate state
                setDollarRate(data.rates.ILS);
            })
            .catch((error) => {
                console.error("Error fetching dollar rate:", error);
            });
    }, []);

    useEffect(() => {
        if (isCreatingInvoice) {
            setInternalMessage("Creating invoice please wait");
        } else {
            setInternalMessage(null);
        }
    }, [isCreatingInvoice]);

    const handleUpdateAmount = (entryKey, e) => {
        let newValue = inAmount.replace(".", "");

        if (newValue === "0000") {
            newValue = "";
        }

        newValue += entryKey.toString();

        const formattedValue = newValue.slice(0, -2) + "." + newValue.slice(-2);
        handlePropertyChange(e, "amount", formattedValue);
    };

    const handleReplaceAmount = (entryKey, e) => {
        let newValue = inAmount.replace(".", "");
        if (newValue === "0000") {
            newValue = "";
        }
        newValue = entryKey.toString();

        handlePropertyChange(null, "amount", newValue);
    };

    const handleUpdateClear = (entryKey) => {
        let newValue = inAmount.replace(".", "");

        if (newValue.length === 0) {
            return;
        }

        newValue = newValue.slice(0, -1);

        while (newValue.length < 4) {
            newValue = "0" + newValue;
        }

        const formattedValue = newValue.slice(0, -2) + "." + newValue.slice(-2);
        handlePropertyChange(null, "amount", formattedValue);
    };

    const handleClearAll = () => {
        const formattedValue = "00" + "." + "00";
        handlePropertyChange(null, "amount", formattedValue);
    };

    const handleBackClicked = () => {
        if (backCallback) {
            backCallback();
        }
    };

    const getButtonStyle = (type) => ({
        flex: 1,
        backgroundColor:
            paymentType === type ? "#e14954" : "#6E7187", // Light blue when selected, very light blue when not selected
        color: paymentType === type ? "#FFFFFF" : "#FFFFFF", // Light blue when selected, very light blue when not selected
        marginRight: "10px",
    });

    const getButtonStyle1 = (type) => ({
        flex: 1,
        backgroundColor:
            selectedButton === type ? "#e14954" : "#6E7187", // Light blue when selected, very light blue when not selected
        color: selectedButton === type ? "#FFFFFF" : "#FFFFFF", // Ensure text is visible
        marginRight: "10px",
        border: selectedButton === type ? "1px solid #000" : "1px solid #ccc", // Add border for selected button
    });

    const [selectedButton, setSelectedButton] = useState("");

    const handleButtonChange = (event, newButton) => {
        setSelectedButton(newButton);
    };

    useEffect(() => {
        if (selectedButton && selectedButton === "Deferred") {
            setOrderOnHouse(false);
        } else if (selectedButton && selectedButton === "OTH") {
            setOrderOnHouse(true);
        } else {
            setOrderOnHouse(false);
        }
    }, [selectedButton]);

    const changeCustomer = (customer) => {
        setChangeCustomerDialogOpen(true);
    };

    const onConfirmCustomerChanged = (customerName, address) => {
        refetchCustomers();
        refetchAddresses();
        setSelectedCustomer(customerName);
        // if (address) {
        //     setSelectedAddress(address);
        // }
        setErrorMessage(null);
        setChangeCustomerDialogOpen(false);
        // assignCustomerToTable(customerName, address);
    };

    const onCustomerSelected = (customer, address) => {
        setSelectedCustomer(customer);
        setErrorMessage(null);
        setChangeCustomerDialogOpen(false);
    };

    const handleCustomerChangeClose = () => {
        setChangeCustomerDialogOpen(false);
    };

    return (
        <div className={classes.AddPaymentWidgetWrap}>
            {/* <Backdrop open={isLoading} className={classes.OrderItemsBackdrop}> */}
                {/* {" "} */}
                {/* <CircularProgress />{" "} */}
            {/* </Backdrop> */}
            <div className={classes.AddPaymentWidget}>
                <div className={classes.SmallTablePlaceholderWrapper}>
                    <SmallTablePlaceholder
                        backCallback={handleBackClicked}
                        tables={tables}
                        internalMessage={internalMessage}
                    />
                </div>
                <div className={classes.CurrencyAmount}>
                    {/* <div className="CurrencyAmount_Currencies">
                            {currencies.map((entry, index) => {
                                console.log(entry);
                                return (
                                    <div key={index}>
                                        <span>{entry.currencyIcon} </span>
                                        <span>{entry.currencyName}</span>
                                    </div>
                                );
                            })}
                        </div> */}
                    <div className="CurrencyAmount_Currencies">
                        <div>
                            <span>$</span>
                            <span>{`${dollarRate}`}</span>
                        </div>
                    </div>
                    <div className="CurrencyAmount_OrderAmount">
                        <div>Order Amount</div>
                        <div
                            onClick={(e) =>
                                handleReplaceAmount(amountAfterDiscount, e)
                            }
                        >
                            {amountAfterDiscount}
                        </div>
                    </div>
                </div>
                <div className={classes.AmountView}>
                    <div>
                        <div>Enter Amount</div>
                        <div>{inAmount}</div>
                    </div>
                    <div>
                        <div className={classes.Change}>
                            <div className="Change__Title">Change</div>
                            <div className="Change__Amount">
                                {(inAmount - amountAfterDiscount).toFixed(2)}
                            </div>
                            <div className="Change__Currency">₪</div>
                        </div>
                    </div>
                </div>
                <div className={classes.MainContainer}>
                    <div>
                        <div className={classes.Tips}>
                            <div className="Tips__Amounts">
                                {[10, 20, 50, 100, 200].map((entry) => {
                                    return (
                                        <div
                                            key={entry}
                                            onClick={(e) =>
                                                handleReplaceAmount(entry, e)
                                            }
                                            className={classNames("Number", {
                                                IsSelected:
                                                    selectedTip === entry,
                                            })}
                                        >
                                            {entry}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className={classes.Keys}>
                            {[9, 8, 7, 6, 5, 4, 3, 2, 1, 0].map((entry) => {
                                return (
                                    <div
                                        key={entry}
                                        className={classNames("Number")}
                                        onClick={(e) =>
                                            handleUpdateAmount(entry, e)
                                        }
                                    >
                                        {entry}
                                    </div>
                                );
                            })}
                            <div
                                className="Clear"
                                onClick={(e) => handleClearAll()}
                            >
                                C
                            </div>
                            <div
                                className="Delete"
                                onClick={(e) => handleUpdateClear()}
                            >
                                <img src={clear} />
                            </div>
                        </div>
                    </div>
                    <div className={classes.PaymentType}>
                        <div className={classes.VerticalContainer}>
                            {errorMessage && (
                                <div style={{ color: "red" }}>
                                    {errorMessage}
                                </div>
                            )}
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    marginBottom: "1rem",
                                }}
                            >
                                <Button
                                    onClick={() => {
                                        setPaymentType("Cash");
                                        setErrorMessage(null);
                                    }}
                                    style={getButtonStyle("Cash")}
                                >
                                    Cash
                                </Button>
                                <Button
                                    onClick={() => {
                                        setPaymentType("Credit Card");
                                        setErrorMessage(null);
                                    }}
                                    style={getButtonStyle("Credit Card")}
                                >
                                    Credit Card
                                </Button>
                            </div>
                            <div>
                                {userCanGiveDiscount() && (
                                    <div className={classes.Discount}>
                                        <div className="Discount__Title">
                                            Discount
                                        </div>
                                        <div
                                            className={`Discount__Amounts ${
                                                presetDiscount == null
                                                    ? ""
                                                    : "Disabled"
                                            }`}
                                        >
                                            {[0, 5, 10, 15, 20].map((entry) => {
                                                return (
                                                    <div
                                                        key={entry}
                                                        onClick={() =>
                                                            presetDiscount ==
                                                            null
                                                                ? onUpdateDiscount(
                                                                      entry
                                                                  )
                                                                : console.log(
                                                                      presetDiscount
                                                                  )
                                                        }
                                                        className={classNames(
                                                            "Number",
                                                            "DiscountButton",
                                                            {
                                                                IsSelected:
                                                                    selectedDiscount ===
                                                                    entry,
                                                            }
                                                        )}
                                                    >
                                                        {entry}%
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div style={{ width: "100%" }}>
                                <ToggleButtonGroup
                                    style={{ width: "100%", display: "flex" }}
                                    value={selectedButton}
                                    exclusive
                                    onChange={handleButtonChange}
                                    aria-label="payment options"
                                >
                                    <ToggleButton
                                        value="OTH"
                                        aria-label="OTH"
                                        style={getButtonStyle1("OTH")}
                                    >
                                        OTH
                                    </ToggleButton>
                                    <ToggleButton
                                        value="Deferred"
                                        aria-label="Deferred"
                                        style={getButtonStyle1("Deferred")}
                                    >
                                        Deferred
                                    </ToggleButton>
                                    {selectedButton &&
                                        selectedButton === "Deferred" && (
                                            <div>
                                                <IconButton
                                                    className={
                                                        classes.Table_edit_customer
                                                    }
                                                    onClick={() =>
                                                        changeCustomer(
                                                            selectedCustomer
                                                        )
                                                    }
                                                >
                                                    <PersonAddAlt1
                                                        fontSize="x-small"
                                                        color="white"
                                                    />
                                                </IconButton>
                                            </div>
                                        )}
                                </ToggleButtonGroup>
                            </div>
                            {selectedButton && (
                                <div>
                                    {selectedButton === "OTH" && (
                                        <div>Order on House Selected</div>
                                    )}
                                    {selectedButton === "Deferred" && (
                                        <div>
                                            {selectedCustomer ? (
                                                <div>
                                                    Payment for{" "}
                                                    {selectedCustomer}
                                                </div>
                                            ) : (
                                                <div>Select Customer</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className={classes.Actions}>
                    <button
                        className="Btn--Primary"
                        onClick={validateInput}
                        disabled={isMutating === 1}
                    >
                        {isMutating ? (
                            <CircularProgress />
                        ) : (
                            "Confirm Payment & Print receipt"
                        )}
                    </button>
                </div>

                <CustomerDialog
                    dialogOpen={changeCustomerDialogOpen}
                    onCancel={handleCustomerChangeClose}
                    onConfirm={onConfirmCustomerChanged}
                    selectedCustomer={selectedCustomer}
                    customerSelected={onCustomerSelected}
                ></CustomerDialog>
            </div>
        </div>
    );
};

export default AddPaymentWidget;
